import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetDto, GalleryAccessLevel, GalleryDto, GalleryFeedbackOption } from '@picflow/types';
import { Subscription } from 'rxjs';
import { ShareAssetDialogComponent } from 'src/app/account/dialogs/share-asset-dialog/share-asset-dialog.component';
import { getAllowedAndEnabledFeedbackOptions } from 'src/app/lib/get-allowed-feedback-options';
import { DialogService } from 'src/app/services/dialog.service';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { StateService } from 'src/app/services/state.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { AssetContextMenuComponent } from '../asset-context-menu/asset-context-menu.component';

@Component({
  selector: 'app-asset-side-menu',
  templateUrl: './asset-side-menu.component.html',
  styleUrls: ['./asset-side-menu.component.scss'],
  standalone: true,
  imports: [ContextMenuComponent, ButtonDirective, TooltipDirective, SvgComponent, NgIf, AssetContextMenuComponent],
})
export class AssetSideMenuComponent implements OnInit {
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Output() onThumbnailBarOpen = new EventEmitter();
  @Output() onUpload = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onModeChange = new EventEmitter();
  @Input() asset: AssetDto;
  @Input() gallery: GalleryDto;
  @Input() clientMode: boolean;
  @Input() accessLevel: GalleryAccessLevel;
  @Input() thumbnailBarOpen: boolean;
  @Input() mode: 'info' | 'activity' = 'info';
  updateSub: Subscription;
  allowedAndEnabledFeedbackOptions: GalleryFeedbackOption[] = [];

  constructor(public state: StateService, public featureFlags: FeatureFlagsService, private dialog: DialogService) {}

  ngOnInit(): void {
    this.allowedAndEnabledFeedbackOptions = getAllowedAndEnabledFeedbackOptions(
      this.gallery,
      this.state.plan,
      this.accessLevel
    );
  }

  close() {
    this.onClose.emit();
  }

  async onDeleteAsset() {
    this.onDelete.emit();
  }

  openShareDialog() {
    this.dialog.open(ShareAssetDialogComponent, {
      gallery: this.gallery,
      asset: this.asset,
    });
  }

  switchMode(mode: 'info' | 'activity') {
    this.mode = mode;
    this.onModeChange.emit(mode);
  }
}
